<template>
  <div class="FormRequirement">
    <RowGrid :columns="5">
      <Field
        :value="item.name"
        @update:value="$up('item.name', $event)" />
      <Field
        :value="item.requirements.MINIMUM"
        @update:value="$up('item.requirements.MINIMUM', $event)" />
      <Field
        :value="item.requirements.MEDIUM"
        @update:value="$up('item.requirements.MEDIUM', $event)" />
      <Field
        :value="item.requirements.MAXIMUM"
        @update:value="$up('item.requirements.MAXIMUM', $event)" />
      <Btn class="danger sm ib inv noBorder" @click="$emit('remove')">
        <Icon name="cross" />
      </Btn>
    </RowGrid>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.FormRequirement {
  border-bottom: 1px solid $border-color;
  margin-bottom: $grid-unit-half;

  .Field-cont {
    margin: 0;
  }
}
</style>
